<div class="bill">
  <div class="bill-title">
    CONTA
  </div>
  <table class="table table-hover table-striped">
    @if (bill?.items?.length > 0) {
      <thead>
        <tr>
          <th>Qtd</th>
          <th>Item</th>
          <th>Status</th>
          <th>Total</th>
          <th><fa-icon [icon]="faClock"></fa-icon></th>
        </tr>
      </thead>
    }
    <tbody>
      @for (item of items; track item) {
        <tr>
          <td>{{item.quantity}}</td>
          <td>
            {{item.product_name}}
            @if (item.notes) {
              <ul>
                {{item.notes}}
              </ul>
            }
            @if (item.optional_names && item.optional_names.length > 0) {
              <div class="poptionals">
                <i>OPÇÕES:</i>
                <ul>
                  @for (name of item.optional_names; track name) {
                    <li>{{name}}</li>
                  }
                </ul>
              </div>
            }
          </td>
          <td>
            @if (item.status == 'pending') {
              <div class="badge badge-pill badge-danger">PENDENTE</div>
            }
            @if (item.status == 'received') {
              <div class="badge badge-pill badge-success">OK</div>
            }
          </td>
          <td>{{item.product_price * item.quantity | currency:'BRL'}}</td>
          <td>{{item.timeSince}}</td>
        </tr>
      }
      <tr>
        <td></td>
        <td></td>
        <td class="total">TOTAL:</td>
        <td>{{bill?.total_value | currency:'BRL'}}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <br/>
</div>